(function () {

    let scrollObserver = null;

    // ---- Safari back-button scroll fix ----
    // Safari often skips bfcache for this navigation pattern and does a
    // fresh reload instead, which loses the extra pages we appended via JS.
    // We take manual control of scroll restoration so we can re-load those
    // pages first, then restore the exact scroll position ourselves.
    if ("scrollRestoration" in history) {
        history.scrollRestoration = "manual";
    }

    function getGrid() {
        return (
            document.querySelector("#product-grid") ||
            document.querySelector("#blog-grid") ||
            document.querySelector("#collection-grid")
        );
    }

    function getStorageKey() {
        return "infiniteScrollState:" + window.location.pathname + window.location.search;
    }

    function getPagesLoaded() {
        const grid = getGrid();
        return grid ? parseInt(grid.dataset.pagesLoaded || "1", 10) : 1;
    }

    let scrollSaveTimeout = null;

    function saveScrollState() {
        clearTimeout(scrollSaveTimeout);
        scrollSaveTimeout = setTimeout(function () {
            try {
                sessionStorage.setItem(
                    getStorageKey(),
                    JSON.stringify({
                        scrollY: window.scrollY,
                        pagesLoaded: getPagesLoaded()
                    })
                );
            } catch (e) {
                // sessionStorage not available (private mode etc.) — ignore
            }
        }, 200);
    }

    window.addEventListener("scroll", saveScrollState, { passive: true });

    async function restoreScrollState() {
        let saved;

        try {
            saved = JSON.parse(sessionStorage.getItem(getStorageKey()));
        } catch (e) {
            saved = null;
        }

        if (!saved) return;

        let currentPages = getPagesLoaded();
        let safetyCounter = 0;

        while (currentPages < saved.pagesLoaded && safetyCounter < 50) {
            safetyCounter++;

            if (!document.getElementById("infinite-scroll-trigger")) break;

            await loadNextPage();

            const newPages = getPagesLoaded();
            if (newPages === currentPages) break; // no progress, stop
            currentPages = newPages;
        }

        window.scrollTo(0, saved.scrollY);
    }

    window.addEventListener("pageshow", function () {
        // small delay so initInfiniteScroll() has already run and the
        // grid/trigger are present in the DOM
        setTimeout(restoreScrollState, 50);
    });
    // ---- end Safari back-button scroll fix ----

    function initInfiniteScroll() {

        const trigger = document.getElementById("infinite-scroll-trigger");

        if (!trigger) return;

        if (trigger.dataset.initialized === "true") return;

        trigger.dataset.initialized = "true";
        trigger.dataset.loading = "false";

        if (scrollObserver) {
            scrollObserver.disconnect();
        }

        scrollObserver = new IntersectionObserver(function (entries) {

            entries.forEach(function (entry) {

                if (entry.isIntersecting) {
                    loadNextPage();
                }

            });

        }, {
            rootMargin: "300px 0px"
        });

        scrollObserver.observe(trigger);
    }

    function loadNextPage() {

        return new Promise(function (resolve) {

            const trigger = document.getElementById("infinite-scroll-trigger");

            if (!trigger) { resolve(); return; }

            if (trigger.dataset.loading === "true") { resolve(); return; }

            const nextUrl = trigger.dataset.nextUrl;

            if (!nextUrl || nextUrl === "#") { resolve(); return; }

            trigger.dataset.loading = "true";

            if (scrollObserver) scrollObserver.unobserve(trigger);

            const loader = document.querySelector(".infinite-scroll-loader");
            if (loader) loader.hidden = false;

            fetch(nextUrl)

                .then(function (response) {

                    if (!response.ok) {
                        throw new Error("Network Error");
                    }

                    return response.text();

                })

                .then(function (html) {

                    const parser = new DOMParser();

                    const doc = parser.parseFromString(html, "text/html");

                    const currentGrid =
                        document.querySelector("#product-grid") ||
                        document.querySelector("#blog-grid") ||
                        document.querySelector("#collection-grid");

                    const newGrid =
                        doc.querySelector("#product-grid") ||
                        doc.querySelector("#blog-grid") ||
                        doc.querySelector("#collection-grid");

                    if (!currentGrid || !newGrid) {
                        throw new Error("Product Grid Not Found");
                    }

                    if (newGrid.children.length === 0) {
                        removeTrigger();
                        return;
                    }

                    Array.from(newGrid.children).forEach(function (item) {
                        currentGrid.appendChild(item);
                    });

                    currentGrid.dataset.pagesLoaded =
                        (parseInt(currentGrid.dataset.pagesLoaded || "1", 10) + 1).toString();

                    document.dispatchEvent(new CustomEvent("products:loaded"));
                    document.dispatchEvent(new Event("theme:section:load"));
                    document.dispatchEvent(new Event("shopify:section:load"));

                    const newTrigger = doc.querySelector("#infinite-scroll-trigger");

                    if (newTrigger && newTrigger.dataset.nextUrl) {

                        trigger.dataset.nextUrl = newTrigger.dataset.nextUrl;
                        trigger.dataset.loading = "false";

                        if (scrollObserver) scrollObserver.observe(trigger);

                    } else {

                        removeTrigger();

                    }

                })

                .catch(function (error) {

                    console.error(error);

                    trigger.dataset.loading = "false";

                    if (scrollObserver) scrollObserver.observe(trigger);

                })

                .finally(function () {

                    const loader = document.querySelector(".infinite-scroll-loader");
                    if (loader) loader.hidden = true;

                    resolve();

                });
        });
    }

    function removeTrigger() {

        const trigger = document.getElementById("infinite-scroll-trigger");
        const loader = document.querySelector(".infinite-scroll-loader");

        if (scrollObserver && trigger) scrollObserver.unobserve(trigger);

        if (trigger) trigger.remove();
        if (loader) loader.remove();
    }

    document.addEventListener("DOMContentLoaded", function () {
        initInfiniteScroll();
    });

    document.addEventListener("shopify:section:load", function () {
        initInfiniteScroll();
    });

    document.addEventListener("theme:section:load", function () {
        initInfiniteScroll();
    });

    document.addEventListener("products:loaded", function () {

        if (typeof window.initQuickAdd === "function") {
            window.initQuickAdd();
        }

        if (typeof window.initVariantPickers === "function") {
            window.initVariantPickers();
        }

        if (typeof window.initProductCards === "function") {
            window.initProductCards();
        }

    });

    // facets.js calls window.refreshLoadMore() after it replaces
    // #ProductGridContainer's innerHTML (filters/sorting/search).
    // Keeping this name so facets.js needs no changes.
    window.refreshLoadMore = function () {

        const trigger = document.getElementById("infinite-scroll-trigger");

        if (trigger) {
            trigger.dataset.initialized = "false";
        }

        initInfiniteScroll();
    };

    window.initLoadMore = initInfiniteScroll;

})();